<template id="nbrResultats">
  <div class="info-recherche" aria-live="polite" role="status" :aria-label="ariaLabelNbrResultat + condamnations.length">
	  <p class="total-results" v-if="!isFetching">{{ condamnations.length != 0 ? condamnations.length + " éléments" : "Aucun élément"  }}</p>
  </div>
</template>


<script>
  export default {
    name:"NombreResultatAfficher",
    props: {
	    nbrResultats: {
          type: Number
	    },
	    condamnations: {
          type: Array
	    },
      isFetching: {
        type: Boolean
      }
	},
    data(){
      return{
          ariaLabelNbrResultat:"Nombre de résultats de recherche "
      }
    }, 
    methods:{
      
    },
    computed: {
     
    }
  }
</script>

<style scoped>

</style>